module.exports = __webpack_public_path__ + "static/media/cookie-icon.cb70927f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/cookie-icon.png
// module id = 640
// module chunks = 0